// Guarded service-worker registration. Refuses to register in dev, iframe,
// Lovable preview hosts, or when ?sw=off is set. Unregisters stale workers
// in those contexts so previews never serve cached HTML.

const STALE_PATHS = ["/sw.js"];

function shouldRefuse(): boolean {
  if (typeof window === "undefined") return true;
  if (!import.meta.env.PROD) return true;
  try {
    if (window.self !== window.top) return true;
  } catch {
    return true;
  }
  const host = window.location.hostname;
  if (host.startsWith("id-preview--") || host.startsWith("preview--")) return true;
  if (host === "lovableproject.com" || host.endsWith(".lovableproject.com")) return true;
  if (host === "lovableproject-dev.com" || host.endsWith(".lovableproject-dev.com")) return true;
  if (host === "beta.lovable.dev" || host.endsWith(".beta.lovable.dev")) return true;
  if (new URLSearchParams(window.location.search).get("sw") === "off") return true;
  return false;
}

async function unregisterStale() {
  if (typeof navigator === "undefined" || !("serviceWorker" in navigator)) return;
  try {
    const regs = await navigator.serviceWorker.getRegistrations();
    await Promise.allSettled(
      regs
        .filter((r) => STALE_PATHS.some((p) => r.active?.scriptURL.endsWith(p) || r.installing?.scriptURL.endsWith(p) || r.waiting?.scriptURL.endsWith(p)))
        .map((r) => r.unregister()),
    );
  } catch {
    /* ignore */
  }
}

export function registerPwa() {
  if (typeof window === "undefined") return;
  if (shouldRefuse()) {
    void unregisterStale();
    return;
  }
  if (!("serviceWorker" in navigator)) return;
  // vite-plugin-pwa emits /sw.js at the site root.
  const register = () => {
    void navigator.serviceWorker
      .register("/sw.js", {
        scope: "/",
        updateViaCache: "none",
      })
      .catch(() => {
        // Registration failure must not block the storefront.
      });
  };

  if (document.readyState === "complete") {
    register();
  } else {
    window.addEventListener("load", register, { once: true });
  }
}

